const clientReports = {
  fileName: "اسم الملف",
  size: "الحجم",
  uploadedBy: "تم الرفع بواسطة",
  uploadDate: "تاريخ ووقت الرفع",
  actions: "الإجراءات",
  uploadReport: "رفع تقرير",
  downloadAll: "تنزيل الكل",
  searchPlaceholder: "ابحث باسم التقرير",
  showingRange: "عرض {from}-{to} من {total} تقرير",
  emptyTitle: "لا توجد تقارير بعد",
  emptyDescription: "قم برفع أول تقرير لمشاركته مع عميل هذه الفعالية.",
  noResultsTitle: "لا توجد تقارير",
  noResultsDescription: "لا توجد تقارير مطابقة لبحثك.",
  downloadError: "عذراً، تعذر تنزيل الملف.",
  downloadRetryError: "تعذر تنزيل الملف. يرجى المحاولة مرة أخرى.",
  unknownUploader: "غير مسجل",
  fileTypes: {
    pdf: "مستند PDF",
    png: "صورة PNG",
    jpg: "صورة JPG",
    xlsx: "جدول Excel",
    html: "مستند HTML",
  },
  uploadModal: {
    title: "رفع تقرير",
    description: "شارك تقريراً مع عميل هذه الفعالية.",
    submit: "رفع",
    uploadClickToUpload: "اضغط للرفع",
    uploadDragHint: "أو اسحب وأفلت",
    uploadHint: "PNG أو JPG أو PDF أو Excel أو HTML (بحد أقصى 10 ميجابايت)",
    uploadTypeError: "الصيغ المقبولة هي PNG و JPG و PDF و Excel و HTML فقط",
    uploadMaxSizeError: "الحد الأقصى للحجم 10 ميجابايت",
    readyToUpload: "جاهز للرفع",
    removeFile: "إزالة الملف",
  },
  downloadModal: {
    title: "تنزيل التقرير",
    readyToDownload: "جاهز للتنزيل",
  },
  delete: "حذف",
  deleteModal: {
    title: "حذف التقرير",
    uploadedOn: "تم الرفع في {date}",
    warning: "سيتم حذف الملف لدى كل من الشركة والعميل ولا يمكن استرجاعه.",
    confirmQuestion: "هل أنت متأكد أنك تريد حذف هذا التقرير؟",
    confirm: "حذف",
    success: "تم حذف التقرير بنجاح",
    error: "تعذر حذف التقرير. يرجى المحاولة مرة أخرى.",
  },
  previewModal: {
    unsupportedType:
      "المعاينة غير متاحة لهذا النوع من الملفات. قم بتنزيل الملف لعرضه.",
    loadError: "تعذر تحميل المعاينة",
    pageOf: "صفحة {page} من {pages}",
    previousPage: "الصفحة السابقة",
    nextPage: "الصفحة التالية",
    sheetTruncated:
      "يعرض أول {rows} صف. نزّل الملف للحصول على الورقة كاملة.",
  },
  downloadAllModal: {
    title: "تنزيل كل التقارير",
    submit: "تنزيل الكل",
    selectedCount: "تم تحديد {count} من ملفات التقارير",
    loading: "جارٍ تجهيز التقارير...",
  },
};

export default clientReports;
